"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _makeStyles = _interopRequireDefault(require("@material-ui/styles/makeStyles"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var styles = (0, _makeStyles.default)(function (theme) {
  return {
    greeting: {
      fontSize: "1.25rem",
      fontWeight: theme.typography.fontWeightBold,
      marginBottom: theme.spacing(1)
    },
    orderNumber: {
      marginTop: theme.spacing(4)
    },
    text: {
      marginTop: theme.spacing(2)
    },
    contact: {
      marginTop: theme.spacing(4)
    }
  };
});
var _default = styles;
exports.default = _default;